export const GET_PACKINGHOUSE = "GET_PACKINGHOUSE";
export const GET_PACKINGHOUSE_UPDATE = "GET_PACKINGHOUSE_UPDATE";
export const COPY_PACKINGHOUSE = "COPY_PACKINGHOUSE"